'use client';
import { CommerceModel } from 'api-types';
import { sendGTMEvent } from '../sendGTMEvent';
import { productListItemToGAItem } from '../productMappers/productListItemToGAItem';

/**
 * Tracks a completed purchase event for Google Analytics 4.
 * 
 * This function sends a purchase event with complete order details including
 * transaction ID, total value, currency, tax, shipping, and item details.
 * 
 * @param order - The order receipt data containing transaction details
 */
export const trackPurchase = (order: CommerceModel.OrderReceipt) => {
  console.log('trackPurchase', order);
  // Extract order financial details
  const transactionId = order.id ?? order.orderNumber;
  const orderValue = order.totalPrice?.taxedPrice || 0;
  const orderCurrency = order.tracking?.currencyCode || order.totalPrice?.displayRawValue?.split(" ")[1] || 'DKK';
  const orderTax = parseFloat(order.tracking?.tax || '0');
  const orderShipping = order.shippingPrice?.taxedPrice || 0;

  // Map order items to GA4 format
  const items = order.lines?.map((line: CommerceModel.LineItem) =>
    productListItemToGAItem(line)
  ) || [];

  sendGTMEvent({
    event: 'purchase',
    ecommerce: {
      transaction_id: transactionId,
      value: orderValue,
      currency: orderCurrency,
      tax: orderTax,
      shipping: orderShipping,
      items,
    },
  });
};
